import { render, staticRenderFns } from "./TwitterWidget.vue?vue&type=template&id=930da66e&"
import script from "./TwitterWidget.vue?vue&type=script&lang=js&"
export * from "./TwitterWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports